import {
  Injector,
  Pipe,
  PipeTransform
} from '@angular/core';


@Pipe({
  name: 'dynamicPipe'
})
export class DynamicPipe implements PipeTransform {

  public constructor(public injector: Injector) {
  }

  transform(value: any, pipeToken: any, pipeArgs: any[]): any {
    if (!pipeToken) {
      return value;
    } else {
      // let pipe = this.injector.get(pipeToken);
      // return pipe.transform(value, ...pipeArgs);

      return pipeToken.transform(value, ...pipeArgs);
    }
  }
}
